import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_CUSTOM_INTEGRATION_ENABLED is set to "true" on the server.
// Reads from the public /app-config endpoint — no auth required.
export const useCustomIntegrationEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isCustomIntegrationEnabled ?? false;
};
